<style lang="scss">
.ivu-select-multiple .ivu-tag {
    height: inherit !important;
    line-height: inherit !important;
    padding: 3px 8px 6px;
}

.hidefooter .ivu-modal-footer {
    display: block !important;
}

.searchb2c textarea.ivu-input {
    font-size: 12px;
}
</style>

<template>
    <div class="search-wrap searchb2c">
        <article class="search-main clearfix">
            <div class="pull-left">
                <Form :label-width="100" inline>
                    <FormItem
                        :label="
                            $t('global.common.organization', {
                                defaultValue: '组织',
                            })
                        "
                    >
                        <Select
                            v-model="formData.IN_orgId"
                            filterable
                            multiple
                            :max-tag-count="2"
                            style="width: 200px"
                        >
                            <Option
                                v-for="item in getOrgList"
                                :value="item.value"
                                :key="item.id"
                                >{{ item.label }}
                            </Option>
                        </Select>
                    </FormItem>

                    <FormItem
                        :label="
                            $t('erp.b2c.delivery_warehouse', {
                                defaultValue: '发货仓库',
                            })
                        "
                    >
                        <Select
                            v-model="orgWarehouseCodes"
                            filterable
                            multiple
                            :max-tag-count="2"
                            style="width: 200px"
                        >
                            <Option
                                v-for="item in getwarehousesAll"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}
                            </Option>
                        </Select>
                    </FormItem>

                    <FormItem
                        :label="
                            $t('erp.b2c.search_orderstatus', {
                                defaultValue: '订单状态',
                            })
                        "
                    >
                        <Select
                            v-model="formData.IN_orderStatus"
                            filterable
                            multiple
                            :max-tag-count="2"
                            style="width: 200px"
                        >
                            <Option
                                v-for="item in orderstatusList"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                </Form>

                <Form :label-width="100" inline>
                    <FormItem
                        :label="
                            $t('global.common.createdtime', {
                                defaultValue: '创建时间',
                            })
                        "
                    >
                        <DatePicker
                            type="daterange"
                            :options="options"
                            placement="bottom-end"
                            placeholder="Select date"
                            style="width: 200px"
                            ref="createdAt"
                            :value="getCreatedAtDate"
                            @on-change="createTime"
                        ></DatePicker>
                    </FormItem>

                    <FormItem
                        :label="
                            $t('erp.b2c.latest_time', {
                                defaultValue: '最晚发货时间',
                            })
                        "
                    >
                        <DatePicker
                            type="daterange"
                            :options="options"
                            placement="bottom-end"
                            placeholder="Select date"
                            style="width: 200px"
                            ref="warehouseExpectedShipDate"
                            :value="getWarehouseExpectedShipDate"
                            @on-change="warehouseExpectedShipDate"
                        ></DatePicker>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.b2c.is_it_abnormal', {
                                defaultValue: '是否异常',
                            })
                        "
                    >
                        <Select
                            v-model="is_exception"
                            clearable
                            style="width: 200px"
                        >
                            <Option
                                v-for="item in systemShipServiceLevel"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                </Form>
            </div>
            <div class="pull-right">
                <Form inline>
                    <Button
                        type="primary"
                        @click="update(true)"
                        icon="ios-search"
                        >{{
                            $t("global.common.btn_search", {
                                defaultValue: "查询",
                            })
                        }}</Button
                    >
                    <Button @click="resetdata" icon="md-refresh">{{
                        $t("global.common.btn_reset", { defaultValue: "重置" })
                    }}</Button>
                    <Button type="dashed" @click="isOpen = !isOpen"
                        >{{
                            $t("global.common.btn_more", {
                                defaultValue: "更多查询",
                            })
                        }}
                        <Icon
                            type="ios-arrow-down"
                            class="margin-left-5"
                        ></Icon>
                    </Button>
                </Form>
            </div>
        </article>
        <transition name="slide-both">
            <div v-show="isOpen">
                <Form class="search-other" :label-width="100" inline>
                    <FormItem
                        :label="
                            $t('erp.distribution.isship', {
                                defaultValue: '是否加急',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select
                            clearable
                            v-model="formData.EQ_systemShipServiceLevel"
                        >
                            <Option
                                v-for="item in systemShipServiceLevel"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}
                            </Option>
                        </Select>
                    </FormItem>

                    <FormItem
                        :label="
                            $t('erp.b2c.search_isSFPorder', {
                                defaultValue: '是否SFP订单',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select clearable v-model="formData.EQ_isPrime">
                            <Option
                                v-for="item in primeList"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}
                            </Option>
                        </Select>
                    </FormItem>

                    <FormItem
                        :label="
                            $t('erp.b2c.search_ordernumber', {
                                defaultValue: '订单号',
                            })
                        "
                    >
                        <Input
                            v-model="formData.EQ_orderNo"
                            style="width: 200px"
                            :placeholder="
                                $t('erp.b2c.placeholder_ordernumber', {
                                    defaultValue: '同时支持订单序号/订单号查询',
                                })
                            "
                        ></Input>
                    </FormItem>

                    <FormItem
                        :label="
                            $t('erp.b2c.search_ordertype', {
                                defaultValue: '订单类型',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select
                            v-model="formData.IN_orderType"
                            filterable
                            multiple
                        >
                            <Option
                                v-for="item in ordertypeList"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}
                            </Option>
                        </Select>
                    </FormItem>

                    <!--<FormItem label='项目' style="width:270px;">-->
                    <!--<Select v-model="formData.IN_lineId" filterable multiple>-->
                    <!--<Option v-for="item in productLineAll" :value="item.id" :key="item.id">{{ item.name }}-->
                    <!--</Option>-->
                    <!--</Select>-->
                    <!--</FormItem>-->
                </Form>
            </div>
        </transition>
        <!--<transition>-->
        <!--<Form inline class="search-other">-->
        <!--<Button type="warning" class="margin-right-5" @click="handleModal('backnormal')">恢复正常</Button>-->
        <!--<Button type="primary" class="margin-right-5" @click="handleModal('addnotes')">添加备注</Button>-->
        <!--</Form>-->
        <!--</transition>-->
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
    data() {
        return {
            SYSID: "",
            aaaa: "",
            isOpen: false,
            getCreatedAtDate: [],
            getWarehouseExpectedShipDate: [],
            routerName: this.$route.name,
            states: [],
            orgWarehouseCodes: [],
            is_exception: "",
            formData: {
                IN_orderStatus: ["unshipped", "approved", "assigned", "picked"],
                // IN_orderStatus: '',
                IN_orgId: "",
                IN_lineId: "",
                NE_orgId: "",
                IN_channelId: "",
                EQ_orderNo: "",
                IN_orderType: "",
                GE_createdAt: "",
                LE_createdAt: "",
                GE_latestShipDate: "",
                LE_latestShipDate: "",
                EQ_errorCode: "",
                NE_errorCode: "",
                EQ_isPrime: "",
                EQ_systemShipServiceLevel: "",
            },
            options: {
                shortcuts: [
                    {
                        text: this.$t("global.common.latest_week", {
                            defaultValue: "最近一周",
                        }),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            return [start, end];
                        },
                    },
                    {
                        text: this.$t("global.common.recent_month", {
                            defaultValue: "最近一月",
                        }),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            return [start, end];
                        },
                    },
                    {
                        text: this.$t("global.common.latest_quarter", {
                            defaultValue: "最近一季度",
                        }),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            return [start, end];
                        },
                    },
                ],
            },
            // 订单类型
            ordertypeList: [
                {
                    value: "normally",
                    label: this.$t("erp.b2c.ordertype_normally", {
                        defaultValue: "正常销售",
                    }),
                },
                {
                    value: "celebrity",
                    label: this.$t("erp.b2c.ordertype_celebrity", {
                        defaultValue: "展示订单",
                    }),
                },
                {
                    value: "distribution",
                    label: this.$t("erp.b2c.ordertype_distribution", {
                        defaultValue: "分销订单",
                    }),
                },
                {
                    value: "brush",
                    label: this.$t("erp.b2c.ordertype_brush", {
                        defaultValue: "刷评订单",
                    }),
                },
                {
                    value: "DELIVERY",
                    label: this.$t("erp.b2c.ordertype_delivery", {
                        defaultValue: "发货订单",
                    }),
                },
            ],
        };
    },
    created() {
        let b2cflag = localStorage.get("b2cflag");
        if (!b2cflag) {
            this.getCreatedAtDate = [];
            this.getWarehouseExpectedShipDate = [];
        }

        // this.getorgWarehouse();
    },
    mounted() {
        this.update();
    },
    computed: {
        ...mapState("boss", ["productLineAll", "accountAll"]),
        ...mapGetters("dictionary", ["getOrgList", "getWarehouseList"]),
        ...mapGetters("dictionary", ["getNewAllWarehouseIdList"]),

        getwarehousesAll() {
            let existCode = [];
            let arr = [];
            this.getNewAllWarehouseIdList.map((item) => {
                if (item.attach.warehouseType == 1) {
                    // console.log(item)
                    if (existCode.indexOf(item.attach.code) < 0) {
                        existCode.push(item.attach.code);
                        // console.log(existCode)
                        let json = {
                            value: item.attach.code,
                            label: item.label,
                        };
                        arr.push(json);
                    }
                }
            });
            // console.log(arr)
            return arr;
        },

        // 是否加急订单
        systemShipServiceLevel() {
            return [
                {
                    value: "1",
                    label: this.$t("erp.global.yes", { defaultValue: "是" }),
                },
                {
                    value: "0",
                    label: this.$t("erp.global.no", { defaultValue: "否" }),
                },
            ];
        },

        // SFP订单
        primeList() {
            return [
                {
                    value: "Y",
                    label: this.$t("erp.global.yes", { defaultValue: "是" }),
                },
                {
                    value: "N",
                    label: this.$t("erp.global.no", { defaultValue: "否" }),
                },
            ];
        },

        // 订单状态
        orderstatusList() {
            return [
                {
                    value: "unshipped",
                    label: this.$t("erp.b2c.orderstatus_unshipped", {
                        defaultValue: "未发货",
                    }),
                },
                {
                    value: "approved",
                    label: this.$t("erp.b2c.orderstatus_approved", {
                        defaultValue: "已审核",
                    }),
                },
                {
                    value: "assigned",
                    label: this.$t("erp.b2c.orderstatus_assigned", {
                        defaultValue: "已分配",
                    }),
                },
                {
                    value: "picked",
                    label: this.$t("erp.b2c.orderstatus_picked", {
                        defaultValue: "已配货",
                    }),
                },
            ];
        },

        accountsAll() {
            return this.accountAll.sort(function (a, b) {
                return a.title.localeCompare(b.title);
            });
        },
        newtimes() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },
        propsData() {
            return [
                {
                    label: this.$t("global.common.organization", {
                        defaultValue: "组织",
                    }),
                    key: "IN_orgId",
                    tag: "Select",
                    value: this.getOrgList,
                },

                {
                    label: this.$t("erp.b2c.delivery_warehouse", {
                        defaultValue: "发货仓库",
                    }),
                    key: "orgWarehouseCodes",
                    tag: "Select",
                    value: this.getwarehousesAll,
                    deletetag: "deletetag",
                },
                {
                    label: this.$t("erp.b2c.search_orderstatus", {
                        defaultValue: "订单状态",
                    }),
                    key: "IN_orderStatus",
                    tag: "Select",
                    value: this.orderstatusList,
                    props: "multiple",
                },
                {
                    label: this.$t("global.common.createdtime", {
                        defaultValue: "创建时间",
                    }),
                    key: ["GE_createdAt", "LE_createdAt"],
                    tag: "timearray",
                },
                {
                    label: this.$t("erp.b2c.table_urgentorder", {
                        defaultValue: "最晚发货时间",
                    }),
                    key: ["GE_latestShipDate", "LE_latestShipDate"],
                    tag: "timearray",
                },
                {
                    label: this.$t("erp.b2c.is_it_abnormal", {
                        defaultValue: "是否异常",
                    }),
                    key: "is_exception",
                    tag: "Select",
                    value: this.systemShipServiceLevel,
                    deletetag: "deletetag",
                },
                {
                    label: this.$t("erp.b2c.isship", {
                        defaultValue: "是否加急",
                    }),
                    key: "EQ_systemShipServiceLevel",
                    tag: "Select",
                    value: this.systemShipServiceLevel,
                },
                {
                    label: this.$t("erp.b2c.search_isSFPorder", {
                        defaultValue: "是否SFP订单",
                    }),
                    key: "EQ_isPrime",
                    tag: "Select",
                    value: this.primeList,
                },
                {
                    label: this.$t("erp.b2c.search_ordernumber", {
                        defaultValue: "订单号",
                    }),
                    key: "EQ_orderNo",
                },
                {
                    label: this.$t("erp.b2c.search_ordertype", {
                        defaultValue: "订单类型",
                    }),
                    key: "IN_orderType",
                    tag: "Select",
                    value: this.ordertypeList,
                    props: "multiple",
                },
            ];
        },
    },
    methods: {
        handleModal(type, id) {
            this.$parent.handleOperate(id, type);
        },
        getorgWarehouse() {
            let warehouseArr = this.warehousesAll;

            this.formData.IN_orgWarehouseId = warehouseArr;
        },
        update(type, parms) {
            let flag = 1;
            if (this.formData.IN_orderStatus == "") {
                flag = 0;
                this.formData.IN_orderStatus = [
                    "unshipped",
                    "approved",
                    "assigned",
                    "picked",
                ];
            }
            if (this.is_exception == "0") {
                this.formData.EQ_errorCode = "unexception";
                this.formData.NE_errorCode = "";
            }
            if (this.is_exception == "" || this.is_exception == undefined) {
                this.formData.EQ_errorCode = "";
                this.formData.NE_errorCode = "";
            }
            if (this.is_exception == "1") {
                this.formData.EQ_errorCode = "";
                this.formData.NE_errorCode = "unexception";
            }
            const formdata = { ...this.formData };
            this.$emit("on-update", {
                search: formdata,
                page: 1,
                orgWarehouseCodes: this.orgWarehouseCodes,
                is_exception: this.is_exception,
            });

            // 设置会本土时间
            this.$momenttimezone.tz.setDefault("Asia/Beijing");
            // console.log(this.$momenttimezone.tz.guess())
            // if (flag == 0) {
            //     this.formData.IN_orderStatus = '';
            // }
        },

        resetdata() {
            this.formData = {
                IN_orderStatus: "",
                IN_orgId: "",
                IN_lineId: "",
                NE_orgId: "",
                IN_channelId: "",
                EQ_orderNo: "",
                IN_orderType: "",
                GE_createdAt: "",
                LE_createdAt: "",
                GE_latestShipDate: "",
                LE_latestShipDate: "",
                EQ_errorCode: "",
                NE_errorCode: "",
                EQ_isPrime: "",
                EQ_systemShipServiceLevel: "",
            };
            this.is_exception = "";
            this.orgWarehouseCodes = "";
            this.getCreatedAtDate = [];
            this.getWarehouseExpectedShipDate = [];

            let flag = 1;
            if (this.formData.IN_orderStatus == "") {
                flag = 0;
            }
            this.formData.IN_orderStatus = [
                "unshipped",
                "approved",
                "assigned",
                "picked",
            ];

            this.$emit("on-update", {
                orgWarehouseCodes: this.orgWarehouseCodes,
                search: {
                    ...this.formData,
                },
                page: 1,
            });
        },

        createTime(data) {
            // 设置成美国时间
            this.$momenttimezone.tz.setDefault("America/Los_Angeles");
            let aa = this.$momenttimezone(data[0] + " 00:00:00")
                .utc()
                .format();
            let bb = this.$momenttimezone(data[1] + " 23:59:59")
                .utc()
                .format();
            let day1 = aa.replace("T", " ").replace("Z", "");
            let day2 = bb.replace("T", " ").replace("Z", "");
            this.formData.GE_createdAt = day1;
            this.formData.LE_createdAt = day2;
        },

        warehouseExpectedShipDate(data) {
            // 设置成美国时间
            this.$momenttimezone.tz.setDefault("America/Los_Angeles");

            let aa = this.$momenttimezone(data[0] + " 00:00:00")
                .utc()
                .format();
            let bb = this.$momenttimezone(data[1] + " 23:59:59")
                .utc()
                .format();
            let day1 = aa.replace("T", " ").replace("Z", "");
            let day2 = bb.replace("T", " ").replace("Z", "");
            this.formData.GE_latestShipDate = day1;
            this.formData.LE_latestShipDate = day2;
        },
    },
};
</script>
